var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeventhBenefit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.7895L10.3846 19M15.2308 9L15.7692 16.3684M26 12.1579L21.1538 17.4211",
    stroke: "url(#paint0_linear_41_3275)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5593 32.2105L10.8052 24.3037C10.6021 23.3883 9.79036 22.7368 8.85269 22.7368H7.06142C6.59044 22.7368 6.1833 23.0655 6.08393 23.5259L2.05085 42.2105L1 46.4211L12.5593 58L23.5932 55.3684L30.5894 48.3604C31.3688 47.5796 31.3688 46.3151 30.5894 45.5344L28.5847 43.5263M12.5593 32.2105L9.9322 34.8421M12.5593 32.2105L24.1142 20.636C25.5668 19.1809 27.9247 19.1809 29.3773 20.636V20.636C30.8265 22.0877 30.8265 24.4386 29.3773 25.8903L26.7458 28.5263M21.4915 33.7895L26.7458 28.5263M26.7458 28.5263L29.5385 31.3238C30.318 32.1046 30.318 33.3691 29.5385 34.1499L27.2712 36.4211M23.5932 40.1053L27.2712 36.4211M27.2712 36.4211L30.064 39.2186C30.8434 39.9993 30.8434 41.2638 30.064 42.0446L28.5847 43.5263M25.6949 46.4211L28.5847 43.5263",
    stroke: "url(#paint1_linear_41_3275)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41_3275",
    x1: 26,
    y1: 9,
    x2: 5,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2295EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_41_3275",
    x1: 32,
    y1: 18,
    x2: 1,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2295EF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeventhBenefit);
export default __webpack_public_path__ + "static/media/seventh_benefit.a32d674587ecca6612bc27a3f4efd234.svg";
export { ForwardRef as ReactComponent };